module.exports = __webpack_public_path__ + "img/Icono (1).0fa41dd0.svg";